<template>
  <div class="aiWriter" v-show="showContent">
    <div class="aiWriter-content">
      <div class="head">
        <div class="l">
          <div class="icon"></div>
          <div class="title">Deepseek写稿</div>
        </div>
        <div class="r" >
          <div @click="createNew" class="create"></div>
          <div v-show="showHistoryBtn&&!showHistory" @click="getSearchlog(true);showHistory = true" class="history"></div>
          <div @click="toggleShowContent" class="close"></div>
        </div>
      </div>
      <!-- <div>当前会话id - {{ conversationID }}</div> -->
      <div
        ref="searchResultDom"
        @scroll="calcTop"
        v-show="!showHistory && !showQuestion"
        class="content"
      >
        <div class="tipsContent">
          <div class="t">
            <span>
              <span>{{configInfo.greeting && configInfo.greeting[0].desc}}</span>
            </span>
            {{configInfo.greeting && configInfo.greeting[1].desc}}
          </div>
          <div class="b">{{configInfo.greeting && configInfo.greeting[2].desc}}</div>
        </div>

        <template v-for="(item,index) in searchList">
          <div v-if="item.role == 'user'" class="user">
            <div class="user-wrap">
              <ul class="file_row_container" v-if="item.isUpload||(item.info&&item.info.length)">
                <li v-for="(infoItem, infoIndex) in item.info" :key="infoIndex" class="file-item">
                  <img class="flex_item_img" src="./assets/file.png" />
                  <div
                    class="flex_item_text"
                  >{{ getFileExtension(infoItem.sourcename,item.percent )}}</div>
                </li>
              </ul>
              <p>{{item.content}}</p>
            </div>
          </div>

          <div v-else-if="item.role == 'search'&&searching" class="agent">
            <p class="search">正在拼命生成中…</p>
          </div>
          <div
            v-if="item.role == 'assistant' && (item.reasoningContent||item.text||item.content)"
            class="result"
          >
            <div class="content">
              <div
                class="content-reasoning"
                v-if="item.reasoningContent&&item.reasoningContent.trim&&item.reasoningContent.trim()"
                v-html="item.reasoningContent.trim()"
              ></div>
              <div class="content-content" v-html="(item.text||item.content||'').trim()"></div>
            </div>
            <div class="btns">
              <div class="l" :class="{hide:index!=searchList.length-1||searching||answering}">
                <div class="star"></div>
                <span @click="recreate(index,item)">重新生成</span>
              </div>
              <div class="r">
                <div
                  @mousedown.stop
                  @click="handleExchange(item.content||item.text)"
                  :class="{exchange: true}"
                ></div>
                <div @click="handleCopy(item.content||item.text)" class="copy"></div>
              </div>
            </div>
          </div>
        </template>
        <div @click="stop" class="stop hide" v-if="searching||answering">
          <i class="del"></i>
          <span>停止搜索</span>
        </div>
      </div>
      <!-- 上传按钮 -->
      <div class="upload" v-show="!showHistory&&!searching&&!answering">
        <!-- :disabled="isSending" -->
        <div class="upload_area">
          <button @click="uploadFile">
            <div>
              <img src="./assets/upload.png" />
            </div>
            <span>上传素材</span>

            <input
              v-if="fileList.length < MAZ_FILE_NUM"
              class="input_file"
              type="file"
              ref="uploadFilesBtn"
              @change="handleFileUpload"
              multiple
              accept=".txt, .doc, .docx"
            />
          </button>
          <span class="upload_text">最多支持上传5个文本素材</span>
        </div>

        <div v-show="fileList.length" class="file_row">
          <ul class="file_row_container">
            <li v-for="(item, index) in fileList" :key="index" class="file-item">
              <img class="flex_item_img" src="./assets/file.png" />
              <div class="flex_item_text">{{ getFileExtension(item.sourcename) }}</div>
              <div class="percent">{{ item.percent }}%</div>
              <img
                class="flex_item_img_delete"
                @click="deleteFile(index, item)"
                src="./assets/doc_delete_icon.png"
              />
            </li>
          </ul>

          <div class="row_line"></div>
        </div>
      </div>
      <div
        v-show="!showHistory && !showQuestion"
        class="foot"
        :class="{searching:searching||answering}"
      >
        <!-- <div class="voice"></div> -->
        <div class="input">
          <!-- @keydown.shift-enter="enter"  -->
          <textarea
            @keydown="handleInput"
            maxlength="2000"
            v-model.trim="searchContent"
            placeholder="在此输入你的问题，shift+enter换行"
            type="text"
          />
          <div @click="search" class="search"></div>
        </div>
        <div @click.stop="stop" class="stop" v-if="searching||answering">
          <i class="del"></i>
          <span>停止搜索</span>
        </div>
      </div>

      <div v-show="showHistory" class="historyContent">
        <div class="title">
          <div @click="showHistory = false" class="back"></div>
          <span>历史记录</span>
        </div>
        <div ref="list" @scroll="getScroll($event)" class="content">
          <div class="title">
            <p>以下是14天内的历史对话：</p>
          </div>

          <ul>
            <li>
              <p>本周</p>
              <ul>
                <li
                  @click="showConversation(item.id);showHistory = false"
                  v-for="item in history.week"
                  :key="item.id"
                >
                  <!-- <span>{{ item.id }}</span> -->
                  <i></i>
                  <p>{{item.content}}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>七天以前</p>
              <ul>
                <li
                  @click="showConversation(item.id);showHistory = false"
                  v-for="item in history.sevenDayAgo && history.sevenDayAgo.list"
                  :key="item.id"
                >
                  <i></i>
                  <p>{{item.content}}</p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common';
import { apis } from '@common/config';
import * as config from '@common/config';
import store from '@common/store';
import Upload from '@common/newUpload';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import qs from 'qs';
const MAZ_FILE_NUM = 5;
export default {
  // 智能写稿
  name: 'aiWriter',
  data() {
    return {
      scrollInterval: null,
      keyword: '',
      showContent: false,
      feedBackIndex: 0,
      history: {},
      show: false,
      r: null,
      showHistory: false,
      showQuestion: false,
      isSubmit: false,
      configInfo: {},
      searchContent: '',
      pages: {
        pageIndex: 1,
      },
      searchList: [],
      reason_types: [],
      suggestion: '',
      scrollTop: 0,
      noMore: false,
      // accept=".txt,.doc,.docx"
      fileList: [],
      // 提问，还未有答案时
      searching: false,
      // 正在回答 已经有答案了
      answering: false,
      conversationID: '',
      MAZ_FILE_NUM,
      // 显示历史记录按钮
      showHistoryBtn: false,
    };
  },
  methods: {
    createNew() {
      console.log('进入新建')
      this.stop()
      this.searchContent=''
      this.searchList = [];
      this.fileList = [];
          this.scrollToEnd();
          this.conversationID = '';
          this.showHistory=false
    },
    // todo 再确认逻辑
    async recreate(index, item) {
      // let lastItem = this.searchList[index - 1];
      // console.log('重新生成 上一条的提问', lastItem);
      if (this.searching || this.answering) {
        this.$toast('正在拼命生成中');
        return;
      }

      let info = {
        model: 'DeepSeek',
        randomid: this.conversationID,
        is_afresh: 1,
      };
      // if (lastItem.info && lastItem.info.length) {
      //   let file_ids = lastItem.info.map((e) => e.id).join(',');
      //   info.file_ids = file_ids;
      // }
      // 控制 生成中的显示
      this.searching = true;

      this.searchList.splice(index, 1, {
        role: 'search',
      });

      console.log('提问 param', info);

      this.scrollToEnd();

      // return;
      this.askQuestion(info)
        .then((res) => {
          console.log('回答完成', res);
        })
        .catch((err) => {
          console.log('回答 发生错误', err);
        });
    },
    generateUniqueId() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    // 上传文件
    handleFileUpload(e) {
      let fList = Array.from(e.target.files);
      console.log('上传的 文件', fList);
      if (fList.length + this.fileList.length > MAZ_FILE_NUM) {
        this.$toast(`最多支持上传${MAZ_FILE_NUM}个文本素材`);
        e.target.value = null;
        return;
      }

      this.uploadCompleted = false;
      // 上传文件需要的信息
      let fileList = [];
      // 会话需要的信息
      let fileInfoList = [];
      let promiseList = [];
      console.log('promiseList 前', promiseList);

      for (let index in fList) {
        let file = fList[index];
        let uploadCtrlAbort = new AbortController();
        let unique_id = this.generateUniqueId();
        console.log('第', index, '个文件', unique_id, file.name);
        // 用来展示的 file 信息
        let fileInfo = {
          sourcename: file.name,
          percent: 0,
          unique_id,
          uploadCtrlAbort,
        };
        fileInfoList.push(fileInfo);
        promiseList.push(
          common
            .myAxiosUploadFile(
              apis.addfiles,
              { [`file[${index}]`]: file },
              {
                signal: uploadCtrlAbort.signal,
                onUploadProgress: (progressEvent) => {
                  let index = this.fileList.findIndex((item) => item.unique_id === unique_id);
                  let item = this.fileList[index];

                  // 计算上传百分比
                  const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  this.fileList.splice(index, 1, {
                    ...item,
                    percent: percentCompleted,
                  });
                  console.log(index, file.name, percentCompleted + '% uploaded');
                },
              }
            )
            .then((r) => {
              console.log('上传 r', r);
              if (r) {
                console.log('myAxiosUploadFile r', r.file_ids);
                let index = this.fileList.findIndex((item) => item.unique_id === unique_id);
                let item = this.fileList[index];

                this.fileList.splice(index, 1, {
                  ...item,
                  id: r.file_ids,
                });
                return r.file_ids;
              } else {
                let index = this.fileList.findIndex((item) => item.unique_id === unique_id);
                // 错误的 就把这个文件 删掉
                this.fileList.splice(index, 1);
              }
            })
            .catch((e) => {
              console.log('上传失败 e', file, e);
              return '';
            })
        );
      }
      this.fileList = this.fileList.concat(fileInfoList);

      Promise.allSettled(promiseList).then((res) => {
        console.log('上传 allSettled', res);
        this.uploadCompleted = true;
      });
      this.scrollToEnd();

      e.target.value = null;
    },

    handleCopy(content) {
      console.log('handleCopy', content);

      // 创建一个临时的 textarea 元素
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = content;

      // 将其添加到 DOM 中
      document.body.appendChild(tempTextArea);

      // 选中并复制内容到剪贴板
      tempTextArea.select();
      document.execCommand('copy');

      // 移除临时的 textarea 元素
      document.body.removeChild(tempTextArea);
      this.$toast('复制成功');
      console.log('Content copied to clipboard');
    },
    handleExchange(html) {
      console.log('handleExchange', html);
      this.$emit('copy', html);
    },
    stop() {
      let needStopRequest = this.searching||this.answering
      // 如果当前还在搜索 还没生成答案
      if (this.searching) {
        this.ctrlAbout && this.ctrlAbout.abort();
        this.ctrlAbout = null;
        this.searchList.splice(this.searchList.length - 1, 1);
        this.searching = false;
      }
      // 如果正在回答
      if (this.answering) {
        this.ctrlAbout && this.ctrlAbout.abort();
        this.ctrlAbout = null;
        this.answering = false;
      }
      if(needStopRequest){
        let item = this.searchList[this.searchList.length - 1];
      console.log('item',item)
      return common.myFetch(apis.stopIntelligentWriter, { 
        randomid:this.conversationID,
        model: 'DeepSeek',
        generatedContent: item.content||item.text||'',
        reasoningContent: item.reasoningContent||'',


       }).then((r) => {
        console.log('停止搜索成功',r)
      });
      }
     
    },
    getFileExtension(sourcename, percent) {
      // xx.extension 最多 字数
      let MAX_COUNT = 11;
      // if (percent < 100) {
      //   MAX_COUNT = 9;
      // }

      // 查找最后一个点的索引位置
      const lastIndex = sourcename.lastIndexOf('.');
      let filename = sourcename.substring(0, lastIndex);
      let extension = sourcename.substring(lastIndex);
      if (filename.length > MAX_COUNT) {
        filename = filename.substring(0, MAX_COUNT) + '...';
      }
      // console.log('最后处理完 filename + extension', filename + extension);
      return filename + extension;
    },
    scrollToEnd() {
      this.$nextTick(() => {
        this.$refs.searchResultDom.scrollTop = this.$refs.searchResultDom.scrollHeight;
      });
    },
    askQuestion(info) {
      //  根据环境来
      let origin = process.env=='development'?'https://devepm1.netapitest.com' : location.origin;
      console.log('origin',origin)
      const VUE_APP_Server = origin+'/index.php?r=intelligent/webapi/chat-submit';
      let userKeys = common.userKeys();

      let data = Object.assign(info, userKeys);
      console.log('askQuestion', data);
      this.ctrlAbout = new AbortController();
      return new Promise((resolve, reject) => {
        let eventSourcepost = fetchEventSource(`${VUE_APP_Server}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: qs.stringify(data),
          signal: this.ctrlAbout.signal,
          openWhenHidden: true, //离开页面导致的连接断开可以通过设置 openWhenHidden: true来避免
          onopen(response) {
            console.log('fetchEventSource onopen', response);
          },
          onmessage: (event) => {
            // 最后一项
            let lastItem;
            let conversationLen = this.searchList.length || 0;

            lastItem = this.searchList[conversationLen - 1];

            // 如果是第一次获得答案，去掉上面一条 生成中的气泡
            if (this.searching) {
              let searingItem = this.searchList.splice(conversationLen - 1, 1);
              console.log('searingItem', searingItem);
              this.searching = false;
              this.answering = true;
              // 添加一条答案项
              lastItem = {
                role: 'assistant',
                isLoading: true,
              };
              this.searchList.push(lastItem);
            }

            let { text = '', reasoningContent = '' } = lastItem;

            let { type, value = '' } = JSON.parse((event && event.data) || '{}');

            // 如果接收推理过程
            if (type == 'reasoning_content') {
              reasoningContent += value;
            } else if (type == 'done') {
              console.log('onmessage 完毕');
              this.scrollToEnd();
              return;
            } else {
              text += value;
            }
           
            this.$set(this.searchList, conversationLen - 1, { ...lastItem, text, reasoningContent, isLoading: false });

            console.log('onmessage value',value)
            if(!this.userScrolledUp){
            
              this.scrollToEnd()
            }
            // -------------
            // 成功之后满足某些条件可以使用AbortController关闭连接
            // this.ctrlAbout.abort()
          },
          onerror: (err) => {
            // 服务异常
            console.log(err);
            reject(err);
          },
          onclose: () => {
            this.ctrlAbout && this.ctrlAbout.abort();
            // 服务关闭
            this.ctrlAbout = null;
            this.answering = false;
            console.log('请求完毕 onclose');
            resolve('回答完毕');
          },
        });
      });
    },
    showConversation(randomid) {
      console.log('showConversation ', randomid);
      this.conversationID = randomid;
      this.searchContent = '';
      this.fileList = [];
      return common.myFetch(apis.getIntelligentWriterConversationDetail, { randomid }).then((r) => {
        if (r) {
          console.log('showConversation r', r);
          this.searchList = r || [];
          this.scrollToEnd();
        } else {
          this.searchList = [];
          this.scrollToEnd();
        }
      });
    },
    uploadFile() {
      if (this.fileList.length >= MAZ_FILE_NUM) {
        return this.$toast('最多支持上传5个文档');
      }
      // todo 上传
    },
    createConversation() {
      return common.myFetch(apis.createIntelligentWriteConversation).then((r) => {
        if (r) {
          return r.conversation_id;
        }
      });
    },
    //删除文件
    async deleteFile(index, item) {
      // 如果还在上传中，取消掉请求
      if (item.percent < 100) {
        item.uploadCtrlAbort && item.uploadCtrlAbort.abort();
      }

      this.fileList.splice(index, 1);
    },
    handleInput(event) {
      if (event.key === 'Enter' && event.shiftKey) {
        console.log('Shift + Enter pressed');
        console.log('去 换行');
      } else if (event.key === 'Enter') {
        console.log('去 search');
        event.preventDefault();
        this.search();
      }
    },

    calcTop(e) {
      // console.log(e)
      this.scrollTop = e.target.scrollTop;
      // 是否当前在底部
      const container = this.$refs.searchResultDom;
      const atBottom =
        container.scrollHeight - container.scrollTop <= container.clientHeight + 5;
        
      this.userScrolledUp = !atBottom;
      console.log('userScrolledUp',this.userScrolledUp)
    },
    toggleShowContent() {
      // if(this.showContent){
      //   this.scrollTop = this.$refs.searchResultDom.scrollHeight
      //   console.log(this.$refs.searchResultDom.scrollHeight)
      // }

      this.showContent = !this.showContent;

      if (this.showContent) {
        this.$nextTick(() => {
          this.$refs.searchResultDom.scrollTop = this.scrollTop;
        });
      } else {
        this.stop();
      }
    },
    openDetail(detail, title) {
      let data = {
        type: detail.type,
        id: detail.id,
        create: store.state.create,
        canEdit: false,
        quickEdit: store.state.quickEdit,
        keywords: title,
        search_from: 'bubble',
        search_hit: JSON.stringify(detail.search_hit),
        vector_result: detail.vector_result,
      };
      this.$materialBox(data);
    },
    submitFeedback(is_satisfied) {
      let reason_types = [];

      this.configInfo.feedback.forEach((el) => {
        if (el.selected) {
          reason_types.push(el.id);
        }
      });

      let info = {
        is_satisfied: is_satisfied,
        keyword: this.keyword,
        reason_types: reason_types.join(','),
        suggestion: this.suggestion,
      };
      common.myFetch(config.apis.submitFeedback, info).then((r) => {
        if (r) {
          this.configInfo.feedback.forEach((el) => {
            el.selected = false;
          });
          this.suggestion = '';
          if (is_satisfied == 0) {
            this.isSubmit = true;
          }
        }
      });
    },
    topSearch(searchContent) {
      this.searchList.push({
        type: 'input',
        value: searchContent,
      });

      this.searchList.push({
        type: 'search',
      });

      let info = {
        key_words: searchContent,
        search_from: 'bubble',
        search_model: 3,
        page_type: 'file',
      };
      common.myFetch(config.apis.fileList, info).then((r) => {
        if (r) {
          if (r.list) {
            this.searchList.push({
              type: 'result',
              res: r,
              title: searchContent,
              isZan: false,
            });
          }
          this.showHistoryBtn = true;

          this.$nextTick(() => {
            this.$refs.searchResultDom.scrollTop = this.$refs.searchResultDom.scrollHeight;
          });

          console.log(r);
        }
      });
    },
    async search() {
      let searchContent = this.searchContent;

      if (!this.searchContent) {
        this.$toast('请输入检索关键词');
        return false;
      }
      if (this.searching) {
        return;
      }
      if (this.answering) {
        return;
      }

      // todo
      // this.conversationID = 304;
      if (!this.conversationID) {
        // 新建会话
        let conversationID = (this.conversationID = await this.createConversation());
      }

      let info = {
        prompt: searchContent,
        model: 'DeepSeek',
        randomid: this.conversationID,
        is_afresh: 0,
      };
      if (this.fileList && this.fileList.length) {
        let file_ids = this.fileList.map((e) => e.id).join(',');
        info.file_ids = file_ids;
      }

      this.searchList.push({
        role: 'user',
        content: searchContent,
        // 是否带上文件标志
        isUpload: this.fileList && this.fileList.length,
        info: this.fileList || [],
      });

      // 控制 生成中的显示
      this.searching = true;
      this.searchList.push({
        role: 'search',
      });

      this.searchContent = '';
      this.scrollToEnd();
      this.fileList = [];
      // return;
      this.askQuestion(info)
        .then((res) => {
          console.log('回答完成', res);
          this.showHistoryBtn = true;
        })
        .catch((err) => {
          console.log('回答 发生错误', err);
        });
    },
    open(c, r) {
      this.r = r;
      this.show = true;
      this.showContent = true;
      this.getConfig();
    },
    close() {
      this.show = false;
    },
    getConfig() {
      this.configInfo = {
        greeting: [
          { desc: '你好，我是@radio DeepSeek写稿小助手' },
          { desc: '' },
          {
            desc: `作为你的智能伙伴，我可以为你创作各类文章，创造有趣的内容
你可以在下方上传素材，提出你的要求，让我们一起写作吧`,
          },
        ],
      };
    },
    getViewHistory() {
      common.myFetch(config.apis.viewhistory).then((r) => {
        if (r) {
          console.log('getViewHistory r', r);
        }
      });
    },
    getSearchlog(refresh) {
      // 如果当前正在搜索，要把之前的请求 abort掉
      // this.stop();
      if (refresh) {
        this.pages.pageIndex = 1;
      }
      let info = {
        page: this.pages.pageIndex,
        pagesize: 10,
      };
      // 拿历史记录的接口
      common.myFetch(config.apis.getIntelligentWriterConversation, info).then((r) => {
        if (r) {
          console.log('history', r);
          if (this.pages.pageIndex == 1) {
            this.history = r;
          } else {
            let list = this.history.sevenDayAgo.list;
            if (r.sevenDayAgo.list.length == 0) {
              this.noMore = true;
            }
            list = list.concat(r.sevenDayAgo.list);
            r.sevenDayAgo.list = list;
            this.history = r;
          }
          this.showHistoryBtn = r.is_show;
        }
      });
    },
    async getScroll(e) {
      if (e) {
        if (this.scrollInterval) {
          clearTimeout(this.scrollInterval);
          this.scrollInterval = null;
        }

        this.scrollInterval = setTimeout(() => {
          let containerH = 482;
          let scrollTop = e.target.scrollTop;
          let listHeight = this.$refs.list.offsetHeight;
          console.log('getScroll');
          if (scrollTop + containerH >= listHeight && !this.noMore) {
            this.pages.pageIndex++;
            console.log('getScroll 拿分页');
            this.getSearchlog(false);
          }
        }, 300);
      }
    },
  },
  mounted() {
    // this.showConversation(248);
    // this.$AiMaterial()
    // 拿一下 历史记录，如果没有的话，就隐藏历史按钮
    this.getSearchlog(true);
  },
  created() {},
};
</script>

<style lang="less" scoped>
@import '../../assets/css/global.less';
.aiWriter {
  position: fixed;
  z-index: 1000;
  top: 100px;
  right: 0;
  width: 482px;
  bottom: 0;

  .aiWriter-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: url('./assets/bg.png') no-repeat;
    background-position: -14px -6px;
    box-sizing: border-box;

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;

      border-radius: 12px 12px 0px 0px;

      padding: 0 20px;
      box-sizing: border-box;

      .l {
        display: flex;
        align-items: center;

        .icon {
          display: block;
          width: 22px;
          height: 22px;
          background: url('./assets/icon.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 6px;
        }

        .title {
          font-size: 16px;
          color: #050f0f;
          font-weight: bold;
        }
      }

      .r {
        display: flex;
        align-items: center;

        .create {
          width: 20px;
          height: 20px;
          background: url('./assets/create.png') no-repeat;
          background-position: center center;
          background-size: initial;
          user-select: none;
          cursor: pointer;
        }
        .history {
          width: 20px;
          height: 20px;
          background: url('./assets/history.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
          margin-left: 10px;
        }

        .close {
          width: 20px;
          height: 20px;
          background: url('./assets/sq.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-left: 10px;
          user-select: none;
          cursor: pointer;
        }
      }
    }

    & > .content {
      flex: 1;
      min-height: 0;
      width: 100%;
      overflow-y: auto;
      padding: 6px 20px 14px;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 4px;
      }

      .tipsContent {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 16px 20px;
        box-sizing: border-box;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.8);
        margin-bottom: 20px;

        .t {
          padding-bottom: 14px;
          box-sizing: border-box;
          font-weight: bold;
          font-size: 16px;
          color: #050f0f;
          line-height: 24px;

          & > span {
            position: relative;

            & > span {
              position: relative;
              z-index: 2;
            }

            &:before {
              display: block;
              content: '';
              position: absolute;
              z-index: 1;
              bottom: 0;
              left: 0;
              width: -webkit-fill-available;
              height: 6px;
              background: #80dabb;
            }
          }
        }

        .b {
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
        }
      }

      .likeContent {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .title {
          font-weight: bold;
          font-size: 16px;
          color: #050f0f;
          line-height: 24px;
          margin-bottom: 10px;
        }

        .likebox {
          width: 100%;
          padding: 14px;
          box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
          box-sizing: border-box;
          background: #fff;

          ul {
            display: flex;
            flex-direction: column;
            width: 100%;

            li {
              display: flex;
              align-items: center;
              width: 100%;
              height: 40px;
              background: #f3f5f7;
              border-radius: 12px;
              margin-bottom: 10px;
              padding: 0 10px;
              box-sizing: border-box;
              user-select: none;
              cursor: pointer;

              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }

              .icon1 {
                width: 20px;
                height: 20px;
                background: url('./assets/icon1.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              .icon2 {
                width: 20px;
                height: 20px;
                background: url('./assets/icon2.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 6px;
              }

              p {
                flex: 1;
                min-width: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 500;
                font-size: 13px;
                color: #050f0f;
              }
            }
          }
        }
      }

      .user {
        max-width: 306px;
        margin-left: auto;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
        white-space: pre-wrap;
        ul {
          border-bottom: 1px solid;
          margin-bottom: 10px;
        }
        p {
          word-break: break-all;
          font-family: PingFang-SC, PingFang-SC;
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
        }
        .file-item {
          max-width: 278px;
          height: 40px;
          background: #f3f5f7;
          color: #050f0f;
          margin-top: 0;
          margin-bottom: 10px;
        }
        .user-wrap {
          padding: 9px 14px;
          box-sizing: border-box;
          background: #29b785;
          border-radius: 12px 12px 0px 12px;
          font-weight: 500;
          font-size: 13px;
          color: #ffffff;
          line-height: 22px;
        }
      }

      .agent {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        margin-bottom: 20px;

        p {
          display: flex;
          align-items: center;
          padding: 9px 14px;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 22px;

          &.search {
            &::before {
              display: inline-flex;
              content: '';
              width: 20px;
              height: 20px;
              background: url('./assets/searchIcon.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }
          }
        }
      }
      .result {
        margin-bottom: 20px;
        width: 100%;
        padding: 14px 20px;
        box-sizing: border-box;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.8);

        .content {
          width: 100%;
          padding: 10px 0;
          border-bottom: 1px solid #dddfe7;
          box-sizing: border-box;
          &-reasoning {
            color: #8b8b8b;
            white-space: pre-wrap;
            line-height: 26px;
            font-size: 14px;
            margin-bottom: 15px;
            word-break: break-all;
          }
          &-content {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 14px;
            color: #050f0f;
            white-space: pre-wrap;
            word-break: break-all;
          }
        }

        .btns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding-top: 14px;
          box-sizing: border-box;

          .l {
            display: flex;
            align-items: center;
            user-select: none;
            cursor: pointer;
            &.hide {
              visibility: hidden;
              opacity: 0;
            }
            .star {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/star.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            span {
              font-weight: bold;
              font-size: 13px;
              color: #41b48c;
              text-decoration-line: underline;
            }
          }

          .r {
            display: flex;
            align-items: center;

            .exchange {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/exchange.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 14px;
              user-select: none;
              cursor: pointer;

              &:hover {
                width: 20px;
                height: 20px;
                background: url('./assets/exchangeOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }

              &.on {
                width: 20px;
                height: 20px;
                background: url('./assets/zanOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }

            .copy {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/copy.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 14px;
              user-select: none;
              cursor: pointer;

              &:hover {
                width: 20px;
                height: 20px;
                background: url('./assets/copyOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }
          }
        }
      }

      .fav {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .title {
          font-weight: bold;
          font-size: 16px;
          color: #050f0f;
          line-height: 24px;
          margin-bottom: 10px;
        }

        .fav-list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 68px;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
          padding: 0 14px;
          box-sizing: border-box;

          p {
            display: flex;
            align-items: center;
            width: 160px;
            height: 40px;
            background: #f3f5f7;
            border-radius: 12px;
            border: 1px solid transparent;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 13px;
            color: #050f0f;
            padding: 0 10px;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;

            .origin {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/icon3.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            .full {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/icon2.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            &.on {
              border: 1px solid #41b48c;
              box-sizing: border-box;
            }
          }
        }
      }

      .result {
        width: 100%;
        padding: 14px 20px;
        box-sizing: border-box;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.8);

        .title {
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
          padding-bottom: 10px;
          border-bottom: 1px solid #dddfe7;
          box-sizing: border-box;

          span {
            &::after {
              display: inline-block;
              content: '、';
            }

            &:nth-last-of-type(1) {
              &::after {
                display: none;
                content: '、';
              }
            }
          }
        }

        .content {
          width: 100%;
          padding: 10px 0;
          border-bottom: 1px solid #dddfe7;
          box-sizing: border-box;

          ul {
            width: 100%;
            display: flex;
            flex-direction: column;

            li {
              display: flex;
              align-items: center;
              width: 100%;
              margin-bottom: 18px;
              user-select: none;
              cursor: pointer;

              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }

              .audio {
                display: block;
                width: 20px;
                min-width: 20px;
                height: 20px;
                background: url('./assets/audio.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              .doc {
                display: block;
                width: 20px;
                min-width: 20px;
                height: 20px;
                background: url('./assets/doc.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              .video {
                display: block;
                width: 20px;
                min-width: 20px;
                height: 20px;
                background: url('./assets/video.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              .pic {
                display: block;
                width: 20px;
                min-width: 20px;
                height: 20px;
                background: url('./assets/pic.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              p {
                max-width: calc(100% - 104px);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 500;
                font-size: 13px;
                color: #050f0f;

                em {
                  color: #41b48c;
                  font-style: normal;
                }

                &:hover {
                  color: #41b48c;
                }
              }

              span {
                display: flex;
                justify-content: center;
                align-items: center;
                white-space: nowrap;
                height: 18px;
                border-radius: 10px;
                border: 1px solid #41b48c;
                font-weight: 500;
                font-size: 12px;
                color: #41b48c;
                margin-left: 10px;
                padding: 0 8px;
                box-sizing: border-box;

                &:nth-last-of-type(1) {
                  margin-right: 0;
                }
              }
            }
          }
        }

        .btns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding-top: 14px;
          box-sizing: border-box;

          .l {
            display: flex;
            align-items: center;
            user-select: none;
            cursor: pointer;

            .star {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/star.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 6px;
            }

            span {
              font-weight: bold;
              font-size: 13px;
              color: #41b48c;
              text-decoration-line: underline;
            }
          }

          .r {
            display: flex;
            align-items: center;

            .zan {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/zan.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 14px;
              user-select: none;
              cursor: pointer;

              &:hover {
                width: 20px;
                height: 20px;
                background: url('./assets/zanOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }

              &.on {
                width: 20px;
                height: 20px;
                background: url('./assets/zanOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }

            .cai {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/cai.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 14px;
              user-select: none;
              cursor: pointer;

              &:hover {
                width: 20px;
                height: 20px;
                background: url('./assets/caiOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }
          }
        }
      }

      .noSearch {
        display: flex;
        margin: 14px 0 20px;

        i {
          display: block;
          width: 20px;
          height: 20px;
          min-width: 20px;
          background: url('./assets/searchIcon.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 6px;
        }

        p {
          display: flex;
          flex-wrap: wrap;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 22px;

          span {
            color: #41b48c;
            text-decoration: underline;
            user-select: none;
            cursor: pointer;

            &:nth-last-of-type(1) {
              &::after {
                display: none;
              }
            }

            &::after {
              display: inline-flex;
              content: '、';
            }
          }
        }
      }
    }

    .foot {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 140px;
      background: #ffffff;
      border-radius: 0px 0px 12px 12px;
      padding: 0 10px 0 14px;
      box-sizing: border-box;
      &.searching {
        margin-top: 60px;
      }
      .voice {
        width: 28px;
        height: 28px;
        background: url('./assets/voice.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 14px;
        user-select: none;
        cursor: pointer;
      }

      .input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        min-width: 0;
        height: 100px;
        border-radius: 12px;
        background: #f6f8fb;
        padding: 14px;
        box-sizing: border-box;

        textarea {
          flex: 1;
          min-width: 0;
          height: 100%;
          background: transparent;
          resize: none;

          &::placeholder {
            color: #b9c3c3;
          }
        }

        .search {
          width: 28px;
          height: 28px;
          background: url('./assets/search.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
          margin-left: 10px;
          align-self: flex-end;
        }
      }

      .current {
        position: absolute;
        z-index: 9;
        right: 20px;
        top: -44px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 72px;
        height: 30px;
        background: rgba(231, 232, 233, 1);
        border-radius: 8px;
        user-select: none;
        cursor: pointer;
        font-weight: 500;
        font-size: 13px;
        line-height: 30px;
        color: #050f0f;
      }

      .stop {
        position: absolute;
        z-index: 9;
        left: 20px;
        top: -44px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 92px;
        height: 30px;
        background: rgba(249, 231, 232, 1);
        border-radius: 8px;
        user-select: none;
        cursor: pointer;

        .del {
          display: block;
          width: 14px;
          height: 14px;
          background: url('./assets/del.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 6px;
        }

        span {
          font-weight: 500;
          font-size: 13px;
          line-height: 30px;
          color: #050f0f;
        }
      }
    }

    .historyContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 14px 20px 0 20px;
      box-sizing: border-box;

      & > .title {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #050f0f;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 10px;

        .back {
          width: 16px;
          height: 16px;
          background: url('./assets/back.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          user-select: none;
          cursor: pointer;
          margin-right: 16px;
        }
      }

      & > .content {
        flex: 1;
        min-height: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        padding: 14px 14px 0 14px;
        box-sizing: border-box;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 4px;
        }

        .title {
          padding: 0 6px 0px 6px;
          box-sizing: border-box;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
          margin-bottom: 11px;

          p {
            padding-bottom: 14px;
            border-bottom: 1px solid #dddfe7;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 13px;
            color: #050f0f;
            line-height: 21px;
          }
        }

        & > ul {
          display: flex;
          flex-direction: column;
          width: 100%;

          & > li {
            display: flex;
            flex-direction: column;
            margin-bottom: 12px;

            & > p {
              font-weight: 500;
              font-size: 13px;
              color: #050f0f;
              line-height: 21px;
              margin-bottom: 12px;
            }

            ul {
              display: flex;
              flex-direction: column;
              width: 100%;

              li {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                width: 100%;
                height: 40px;
                background: #f3f5f7;
                border-radius: 12px;
                margin-bottom: 10px;
                padding: 0 12px;
                box-sizing: border-box;
                font-weight: 500;
                font-size: 13px;
                color: #050f0f;
                user-select: none;
                cursor: pointer;

                p {
                  flex: 1;
                  min-width: 0;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                i {
                  display: inline-flex;
                  content: '';
                  width: 8px;
                  height: 8px;
                  background: #41b48c;
                  border-radius: 50%;
                  margin-right: 12px;
                }

                &:nth-last-of-type(1) {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }

    .questionContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 14px 20px 0 20px;
      box-sizing: border-box;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #050f0f;
        line-height: 24px;
        margin-bottom: 10px;
      }

      .content {
        width: 100%;
        height: 432px;
        background: #ffffff;
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        padding: 14px 14px 24px;
        box-sizing: border-box;

        .questionBtns {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          border-bottom: 1px solid #dddfe7;
          box-sizing: border-box;

          li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 161px;
            height: 40px;
            background: #f3f5f7;
            border-radius: 12px;
            margin-bottom: 10px;
            font-weight: 500;
            font-size: 13px;
            color: #050f0f;
            border: 1px solid transparent;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;

            &.on {
              border: 1px solid #41b48c;
              box-sizing: border-box;
            }
          }
        }

        .questionTextarea {
          width: 100%;
          flex: 1;
          min-height: 0;
          padding-top: 9px;
          box-sizing: border-box;

          .t {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            i {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/icon4.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin-right: 4px;
            }

            span {
              font-weight: 500;
              font-size: 13px;
              color: #050f0f;
              line-height: 21px;
            }
          }

          textarea {
            width: 100%;
            height: 148px;
            background: #f6f8fb;
            border-radius: 12px;
            resize: none;
            padding: 14px 20px;
            box-sizing: border-box;
            margin-bottom: 24px;

            &::placeholder {
              font-size: 14px;
              line-height: 21px;
              color: #b9c3c3;
            }
          }

          .btns {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;

            .btn {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 120px;
              height: 32px;
              background: #b9c3c3;
              border-radius: 4px;
              font-size: 14px;
              color: #ffffff;
              font-weight: bold;
              user-select: none;
              cursor: pointer;

              &.on {
                background: #41b48c;
                margin-right: 20px;
              }
            }
          }
        }
      }
    }

    .fallbackContent {
      flex: 1;
      min-height: 0;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 432px;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
        border-radius: 12px;

        img {
          width: 64px;
          height: 64px;
          margin-top: 60px;
          margin-bottom: 20px;
        }

        p {
          position: relative;

          span {
            position: relative;
            font-weight: bold;
            font-size: 16px;
            color: #050f0f;
            line-height: 24px;
            z-index: 2;
          }

          &::before {
            display: block;
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 1;
            width: 100px;
            height: 6px;
            background: #80dabb;
          }
        }

        & > span {
          width: 235px;
          text-align: center;
          font-weight: 500;
          font-size: 13px;
          color: #050f0f;
          line-height: 21px;
          margin-top: 14px;
          margin-bottom: 66px;
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 188px;
          height: 32px;
          background: #41b48c;
          border-radius: 4px;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }
}
.stop {
  position: absolute;
  z-index: 9;
  left: 20px;
  top: -44px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 92px;
  height: 30px;
  background: rgba(249, 231, 232, 1);
  border-radius: 8px;
  user-select: none;
  cursor: pointer;
  &.hide {
    visibility: hidden;
    opacity: 0;
    position: relative;
    z-index: -111;
  }
  .del {
    display: block;
    width: 14px;
    height: 14px;
    background: url('./assets/del.png') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    margin-right: 6px;
  }

  span {
    font-weight: 500;
    font-size: 13px;
    line-height: 30px;
    color: #050f0f;
  }
}

@keyframes translateXShow {
  0% {
    transform: translateX(350px);
  }

  100% {
    transform: translateX(10px);
  }
}
</style>

<style lang="less">
.aiWriter {
  em {
    color: #41b48c;
    font-style: normal;
  }
}

@keyframes translateXShow {
  0% {
    transform: translateX(350px);
  }

  100% {
    transform: translateX(10px);
  }
}
</style>
<style lang="less" scoped>
.file-item {
  display: flex;
  align-items: center;
  // width: 354px;
  height: 40px;
  background: rgba(#515e64, 0.1);
  border-radius: 12px;
  max-width: 354px;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 10px;
  .flex_item_img {
    width: 20px;
  }
  .flex_item_text {
    max-width: 234px;
    margin-left: 4px;
    margin-right: 6px;
    flex: 1;
    white-space: nowrap;
  }
  .percent {
    width: 40px;
  }
  .flex_item_img_delete {
    width: 14px;
    margin-left: 14px;
    cursor: pointer;
  }
}
.upload {
  padding: 0 20px 14px;
}
.upload_area {
  display: flex;
  align-items: center;
  margin-top: 10px;
  input {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
  button {
    position: relative;
    margin-right: 6px;
    width: 98px;
    height: 36px;
    background: #41b48c;
    border-radius: 30px;
    padding: 0 4px;
    box-sizing: border-box;
    border: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;

    &[disabled] {
      border: 1px solid rgba(243, 244, 254, 0.39);
      background: rgba(243, 244, 254, 0.39);
      cursor: not-allowed;
    }
    div {
      width: 28px;
      height: 28px;
      background: #ffffff;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 18px;
      height: 18px;
    }
    span {
      white-space: nowrap;
    }
  }

  .upload_text {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 500;
    font-size: 13px;
    color: #050f0f;
  }
}
</style>
